<script>
import padStart from "lodash/padStart";
const SECOND = 1;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

const padTimer = time => padStart(time, 2, "0");

export default {
  name: "TimeDisplay",
  props: {
    duration: {
      type: Number,
      required: true
    },
    units: {
      type: Array,
      default: () => ["minutes", "seconds"]
    }
  },
  data() {
    return {
      seconds: "00",
      hours: "00",
      minutes: "00",
      days: "00"
    };
  },
  watch: {
    duration: {
      immediate: true,
      handler: "formatTime"
    }
  },
  methods: {
    formatTime() {
      const duration = Math.floor(this.duration);

      const days = Math.floor(duration / DAY);
      const hours = Math.floor((duration % DAY) / HOUR);
      const minutes = Math.floor((duration % HOUR) / MINUTE);
      const seconds = Math.floor((duration % MINUTE) / SECOND);

      this.days = padTimer(days);
      this.hours = padTimer(hours);
      this.minutes = padTimer(minutes);
      this.seconds = padTimer(seconds);
    },
    getValue(name) {
      return this[name];
    },
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name]();
    }
  },
  render(h) {
    const { days, hours, minutes, seconds, duration } = this;

    if (this.hasSlot()) {
      return this.$scopedSlots.default({
        duration,
        days,
        hours,
        minutes,
        seconds
      });
    } else {
      const { units } = this;

      const content = units.map((item, index) => {
        const divider = index + 1 === units.length ? "" : ":";
        const value = this.getValue(item);
        return (
          <span key={index}>
            {value}
            {divider}
          </span>
        );
      });

      return h("span", null, content);
    }
  }
};
</script>
